export default __webpack_public_path__ + "static/media/masjid img2.e7130996.jpg";